const SEMI: Record<string, number> = {
  C: 0,
  'C#': 1,
  Db: 1,
  D: 2,
  'D#': 3,
  Eb: 3,
  E: 4,
  F: 5,
  'F#': 6,
  Gb: 6,
  G: 7,
  'G#': 8,
  Ab: 8,
  A: 9,
  'A#': 10,
  Bb: 10,
  B: 11,
};

/** "C4" / "F#3" -> frequency in Hz (A4 = 440). */
export function noteFreq(name: string): number {
  const m = /^([A-G][#b]?)(-?\d)$/.exec(name);
  if (!m) return 0;
  const semi = SEMI[m[1]];
  const octave = parseInt(m[2], 10);
  const midi = (octave + 1) * 12 + semi;
  return 440 * Math.pow(2, (midi - 69) / 12);
}

/** Chord symbol -> [root, third, fifth] note names in the given octave. */
export function chordNotes(sym: string, octave: number): string[] {
  const m = /^([A-G][#b]?)(m?)$/.exec(sym);
  if (!m) return [];
  const root = m[1];
  const minor = m[2] === 'm';
  const rootSemi = SEMI[root];
  const build = (offset: number): string => {
    const s = (rootSemi + offset) % 12;
    const oct = octave + Math.floor((rootSemi + offset) / 12);
    const name = Object.keys(SEMI).find((k) => SEMI[k] === s && k.length <= 2 && !k.includes('b'));
    return `${name ?? 'C'}${oct}`;
  };
  return [build(0), build(minor ? 3 : 4), build(7)];
}
